import { defineMessages } from "react-intl";
import { ChipVariant, ChipType } from "../../components/chip/types.js";
const localizedGamePlatform = defineMessages({
  [
    0
    /* Me */
  ]: {
    id: "gamePlatform_Me",
    defaultMessage: "Me"
  },
  [
    1
    /* WPK */
  ]: {
    id: "gamePlatform_WPK",
    defaultMessage: "WPK"
  },
  [
    2
    /* BL */
  ]: {
    id: "gamePlatform_BL",
    defaultMessage: "BL"
  },
  [
    3
    /* MemePoker */
  ]: {
    id: "gamePlatform_MemePoker",
    defaultMessage: "MemePoker"
  },
  [
    4
    /* WPTG */
  ]: {
    id: "gamePlatform_WPTG",
    defaultMessage: "WPTG"
  }
});
function getGamePlatformChipsMapping() {
  return {
    [
      0
      /* Me */
    ]: {
      label: localizedGamePlatform[
        0
        /* Me */
      ],
      chipType: ChipType.Status,
      chipVariant: ChipVariant.Grey
    },
    [
      1
      /* WPK */
    ]: {
      label: localizedGamePlatform[
        1
        /* WPK */
      ],
      chipType: ChipType.Status,
      chipVariant: ChipVariant.Blue
    },
    [
      2
      /* BL */
    ]: {
      label: localizedGamePlatform[
        2
        /* BL */
      ],
      chipType: ChipType.Status,
      chipVariant: ChipVariant.LightBlue
    },
    [
      3
      /* MemePoker */
    ]: {
      label: localizedGamePlatform[
        3
        /* MemePoker */
      ],
      chipType: ChipType.Status,
      chipVariant: ChipVariant.Bronze
    },
    [
      4
      /* WPTG */
    ]: {
      label: localizedGamePlatform[
        4
        /* WPTG */
      ],
      chipType: ChipType.Status,
      chipVariant: ChipVariant.Green
    }
  };
}
export {
  getGamePlatformChipsMapping,
  localizedGamePlatform
};
//# sourceMappingURL=gamePlatformChipConfig.js.map
